import React from 'react';
import styles from './Arrows.module.css';

const Arrows = () => (
  <svg
    className={styles.card__arrows}
    width="36"
    height="28"
    viewBox="0 0 19 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0417 3.33335L11.875 6.50002H14.25C14.25 9.12044 12.1204
             11.25 9.5 11.25C8.70041 11.25 7.94041 11.0521 7.28333 10.6959L6.1275 11.8517C7.10125
              12.4692 8.25708 12.8334 9.5 12.8334C12.9992 12.8334 15.8333 9.99919 15.8333
               6.50002H18.2083L15.0417 3.33335ZM4.75 6.50002C4.75 3.8796 6.87958 1.75002 9.5
                1.75002C10.2996 1.75002 11.0596 1.94794 11.7167 2.30419L12.8725 1.14835C11.8987
                 0.530854 10.7429 0.166687 9.5 0.166687C6.00083 0.166687 3.16666 3.00085 3.16666
                  6.50002H0.791664L3.95833 9.66669L7.125 6.50002H4.75Z"
      className={styles.arrows__svg}
    />
  </svg>
);

export default Arrows;
